import { LocalesEnum } from '@/constants/locales';

export const LANGUAGES = [
  { code: LocalesEnum.AZ, label: 'Azərbaycan dili' },
  { code: LocalesEnum.EN, label: 'English' },
  { code: LocalesEnum.RU, label: 'Русский язык' }
];
